var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-thumbnail",style:(("background-image: url('" + _vm.thumbnail + "')")),attrs:{"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }